import React, { forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CrossIcon from 'src/assets/images/CloseProduct.svg';
import ArrowLeft from 'src/assets/images/LeftArrowBlue.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    DialogContentContainer,
    NoUsageHeader,
    NoUsageTitle,
    NoUsageButtonContainer,
    CrossIconImg,
    NoUsageFooterContainer,
    BackButton,
} from './noUsageToReport.styled';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import {
    cancelUsageOrderRequest,
    setShowNoUsageToReportOrCancelPopup,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { sizes } from 'src/styles/Media.styled';
import { getNumberOfDaysBetweenTwoDates } from 'src/utils/dateUtils';
import {
    closeOrderSummaryModalState,
    toggleSearchResult,
} from 'src/pages/orders/redux/actions';
import { unlockOrderFunc } from '../../redux/saga/dataServices';
import { useTranslation } from 'react-i18next';

const CancelSurgeryContainer = forwardRef(({
    cancelSurgeryData,
    backBtnClickHandler,
    isFromOrderDetailsModal,
    showUnidPostponePopup,
}, ref) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { showSearchModal } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );

    const cancelSurgeryBtnsClickHandler = (proceedWithCancellation) => {
        const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
            new Date(),
            cancelSurgeryData?.surgeryDate ||
            cancelSurgeryData?.surgeryStartDate
        );
        if (
            diffBetweenDates > 0 &&
            proceedWithCancellation &&
            !showUnidPostponePopup
        ) {
            dispatch(
                setShowNoUsageToReportOrCancelPopup({
                    showNoUsagePopup: false,
                    showCancelPopup: false,
                    surgeryData: cancelSurgeryData,
                    viewProcedureScreen: false,
                    showUnidPostponePopup: false,
                    isFromOrderDetailsModal,
                    showCaseCancelOrPostpone: false,
                })
            );
            dispatch(
                cancelUsageOrderRequest(
                    { myCaseRef: cancelSurgeryData.myCaseRef },
                    true,
                    isFromOrderDetailsModal
                )
            );
        } else {
            dispatch(
                setShowNoUsageToReportOrCancelPopup({
                    showNoUsagePopup:
                        !showUnidPostponePopup && proceedWithCancellation,
                    showCancelPopup: false,
                    surgeryData: proceedWithCancellation
                        ? cancelSurgeryData
                        : {},
                    viewProcedureScreen: false,
                    showUnidPostponePopup: showUnidPostponePopup,
                    isFromOrderDetailsModal,
                    showCaseCancelOrPostpone: false,
                })
            );
        }
    };

    const redirectToCalendarOrOrdersPage = (isCancelUsage = false) => {
        (cancelSurgeryData?.myCaseRef && cancelSurgeryData?.myCaseRef?.length > 0) && unlockOrderFunc({
            action: 'NoUsageToReport',
            myCaseRefId: cancelSurgeryData?.myCaseRef,
        });
        cancelSurgeryBtnsClickHandler(false);
        if (!isCancelUsage) {
            dispatch(
                closeOrderSummaryModalState({
                    myCaseRef: '',
                    orderSummaryModal: false,
                })
            );
        }
        if (showSearchModal) {
            dispatch(toggleSearchResult(false));
        }
    };

    // ...existing code...

    // Expose redirectToCalendarOrOrdersPage via imperative handle
    useImperativeHandle(ref, () => ({
        redirectToCalendarOrOrdersPage
    }), []);

    return (
        <React.Fragment>
            <DialogContentContainer>
                <NoUsageHeader>
                    <NoUsageTitle>
                        {t('noUsageToReport.cancelSurgeryTitle')}
                    </NoUsageTitle>
                    {/* <CrossIconImg
                        path={CrossIcon}
                        onClick={redirectToCalendarOrOrdersPage}
                    /> */}
                </NoUsageHeader>
                <BackButton
                id={`reportUsage-noUsageToReport-backButton-${cancelSurgeryData?.myCaseRef || 'unknown'}`}
                onClick={() => backBtnClickHandler(false)}>
                    <img src={ArrowLeft}></img>
                    <span>{t('common.backText')}</span>
                </BackButton>
                <StyledTextDiv
                    color={'#000000'}
                    letterSpacing={'-0.11px'}
                    fontSize={'14px'}
                    fontFamily={'AvenirNextWorld Regular'}
                    padding={
                        window.innerWidth <= sizes.mobileDevice
                            ? '15px 0'
                            : '10px 15px 35px 5px'
                    }
                >
                    {t('noUsageToReport.cancelSurgertText')}
                </StyledTextDiv>
                <NoUsageFooterContainer isCancelPopup>
                    <NoUsageButtonContainer>
                        <Button
                            id={'reportUsage-noUsageToReport-cancelSurgeryButton'}
                            show
                            width={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '160px'
                                    : '166px'
                            }
                            height={'38px'}
                            variant={ButtonStyles.cancel}
                            // borderRadius={'19px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={() => redirectToCalendarOrOrdersPage(true)}
                        >
                            {t('noUsageToReport.cancelButton')}
                        </Button>
                        <Button
                            id={'reportUsage-noUsageToReport-okButton'}
                            show
                            width={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '160px'
                                    : '144px'
                            }
                            height={'38px'}
                            // primary
                            variant={ButtonStyles?.primary}

                            margin={
                                window.innerWidth > sizes.mobileDevice &&
                                '0 24px 0 16px'
                            }
                            // borderRadius={'19px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={() => cancelSurgeryBtnsClickHandler(true)}
                        >
                            {t('noUsageToReport.okMsg')}
                        </Button>
                    </NoUsageButtonContainer>
                </NoUsageFooterContainer>
            </DialogContentContainer>
        </React.Fragment>
    );
});

export default CancelSurgeryContainer;
